export const htmlMeta = {
  TITLE:  'Capture Feedback, Build Roadmaps & Boost Satisfaction',
  DESCRIPTION: 'Capture customer feedback from all sources, record sessions & build data-driven roadmaps. Boost NPS, CSAT & reduce churn with ClientCues. Free trial!'
};